import { request } from './client';

export interface SymbolsResponse {
  symbols: string[];
}

export interface FetchSymbolsParams {
  signal?: AbortSignal;
}

export function fetchSymbols(params: FetchSymbolsParams = {}) {
  const { signal } = params;
  return request<SymbolsResponse>({
    path: '/api/symbols',
    signal,
  });
}
